import { b_logo, footerLastImage, homebanner3, legacyImage, outspoken1, outspoken2 } from '@/assets/images';
import React from 'react';
import Slider from "react-slick";
import Image from "next/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIos, ArrowForwardIos, Star, ShoppingCart } from '@mui/icons-material';
import UserSliderStyle from '../../../UserSliderStyle';
import { storeAssigned } from '@/services/Methods/normalMethods';
import { useRouter } from 'next/navigation';

const CustomArrow = ({ className, style, onClick, isError, direction }) => {
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                background: "black",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                zIndex: 10,
                cursor: "pointer",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            onClick={onClick}
        >
            {isError ? (
                <Error className="text-white" />
            ) : (
                direction === 'prev' ? (
                    <ArrowBackIos className="text-white" />
                ) : (
                    <ArrowForwardIos className="text-white" />
                )
            )}
        </div>
    );
};



const SliderSection = () => {
    const router = useRouter();

    const testimonials = [
        {
            id: 1,
            quote: "b:flex gave me my strength back—and my confidence.",
            author: "- Amanda R.",
            bgColor: "bg-[#f5f7fc]"
        },
        {
            id: 2,
            quote: "I joined for the supplements. but what I found was a global family.",
            author: "- David R.",
            bgColor: "bg-[#f5f7fc]"
        },
        {
            id: 3,
            quote: "This business gave me purpose and a way to help others.",
            author: "- Rachel M.",
            bgColor: "bg-[#f5f7fc]"
        }
    ];

    const handleProducts = () => {
        router.push(`/${storeAssigned()}/products`);
    }
    const handleJoinBhip = () => {
        router.push(`/${storeAssigned()}/distributor`);
    }

    return (
        <>
            <UserSliderStyle>
                {/* Testimonials Section */}
                <section className="bg-white">
                    <div className="container mx-auto px-[15px]">
                        <h2 className="xl:text-20px xl:text-[55px] lg:text-[45px] text-[30px] md:[28px] font-bold text-gray-800 text-center xl:mb-[60px] md:mb-[40px] mb-[35px]">
                            real people. real products. real results.
                        </h2>

                        <div className="flex md:flex-row flex-col 2xl:gap-[90px] xl:gap-[50px] gap-[20px]">
                            {testimonials.map((testimonial) => (
                                <div key={testimonial.id} className={`${testimonial.bgColor} xl:rounded-[35px] rounded-[16px] xl:p-[40px] lg:p-[20px] p-[15px] shadow-lg flex flex-col md:text-start text-center`}>
                                    <div className="flex mb-4 md:justify-start justify-center">
                                        {[...Array(5)].map((_, i) => (
                                            <Star key={i} className="text-blue-500 w-5 h-5 !text-[#0388c7]" />
                                        ))}
                                    </div>
                                    <p className="text-black mb-4 lg:text-[22px] md:text-[18px] text-[16px] font-normal leading-(1.5) ">
                                        "{testimonial.quote}"
                                    </p>
                                    <p className="text-black lg:text-[22px] md:text-[18px] text-[16px] font-normal leading-(1.5) mt-auto">{testimonial.author}</p>
                                </div>
                            ))}
                        </div>

                        <div className="text-center">
                            <button
                                className="mt-[50px] bg-[#009cd2] xl:text-[24px] lg:text-[20px] text-[18px] font-bold !no-underline text-white px-6 py-3 rounded-full font-semibold hover:bg-[#0088b8] transition-colors duration-300 w-fit text-left">
                                see more transformations
                            </button>
                        </div>
                    </div>
                </section>

                {/* Main CTA Section */}
                <section className="py-16 bg-white">
                    <div className="container mx-auto px-[15px]">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            {/* Left Column - Text */}
                            <div>
                                <h2 className="text-[30px] xl:text-[56px] md:text-[40px] font-semibold text-black">
                                    your life. your health. your legacy.
                                </h2>
                                <p className="text-black mb-4 2xl:text-[22px] xl:text-[20px] md:text-[18px] text-[16px] font-normal leading-(1.5) m-[40px_0_30px]">
                                    Whether you're here to look better, feel stronger, or build something that lasts—it all begins with one question
                                </p>
                                <p className="text-[20px] font-bold text-black xl:mb-[70px] mb-[50px]">
                                    What's your b:?
                                </p>

                                <div className="flex flex-col sm:flex-row gap-4">
                                    <button
                                        onClick={handleProducts}
                                        className="flex items-center gap-2 bg-[#0388c7] hover:bg-[#0272a7] text-white p-[9px_9px_9px_30px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[24px] md:text-[20px] text-[18px] max-w-[300px] w-full flex justify-center"
                                    >

                                        <span class="flex-1">shop now</span>
                                        <span className='inline-block ml-auto xl:w-[40px] w-[35px] xl:h-[40px] h-[35px] xl:p-0 p-[10px] rounded-[50%] flex  justify-center items-center bg-white xl:p-[10px] p-[6px]'>
                                            {/* <ShoppingCart className="w-10 h-10 text-[#0388c7]" /> */}
                                            <img src="/images/cart-mian.png" alt="" />
                                        </span>

                                    </button>
                                    <button
                                        onClick={handleJoinBhip}
                                        className="flex items-center bg-transparent p-[6px_8px] rounded-[50px]  !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[24px] md:text-[20px] text-[18px] max-w-[300px] w-full flex justify-center border border-[2px] text-[#0388c7] border-[#0388c7] hover:bg-[#0388c7] hover:text-white"
                                    >
                                        join b:hip
                                    </button>
                                </div>
                            </div>

                            {/* Right Column - Image */}
                            <div className="relative h-full">
                                <div className="w-full h-full">
                                    <Image
                                        src={legacyImage}
                                        alt="Hero image"
                                        className="w-full h-full object-cover rounded-[20px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Mission Section */}
                <section className="relative flex items-center justify-center xl:rounded-[60px_60px_0_0] rounded-[20px_20px_0_0] overflow-hidden">

                    <div className="w-full">
                        <div className="w-full h-full bg-gray-200 ">
                            <Image
                                src={footerLastImage}
                                alt="Mission background"
                                className="w-full h-full object-cover !static min-h-[380px]"
                                fill
                            />
                        </div>
                    </div>

                    {/* Text Overlay */}
                    <div className="absolute lg:top-[100px] top-[40px] left-1/2 transform -translate-x-1/2 text-center max-w-[1280px] w-full px-[15px]">
                        <h2 className="xl:text-[55px] md:text-[45px] text-[25px] font-semibold mb-[23px] leading-[1.1] text-white">
                            b:hip — helping • impact • people
                        </h2>
                        <div className="text-lg md:text-xl space-y-4">
                            <p className='xl:text-[22px] lg:text-[20px] text-[16px] xl:leading-[1.5] leading-[1.2] text-white max-w-[1100px] mx-auto'>
                                We're here to make the world a better place—one product, one person, one purpose at a time.
                                Because being your best starts with how you b:
                            </p>

                        </div>
                    </div>
                </section>

                {/* Footer Strip */}
                <section className="bg-[#2c2c2c] text-white py-4">
                    <div className="container mx-auto px-[15px]">
                        <div className="flex flex-col md:flex-row justify-center items-center md:gap-6  xl:gap-[80px] sm:gap-[20px] gap-[10px]">
                            <span className="xl:text-[20px] lg:text-[18px] text-[14px] font-semibold">Cruelty-Free</span>
                            <div className="hidden md:block w-px lg:h-[40px] h-[20px] bg-white"></div>
                            <span className="xl:text-[20px] lg:text-[18px] text-[16px] font-semibold">Free shipping on orders over $50</span>
                            <div className="hidden md:block w-px lg:h-[40px] h-[20px] bg-white bg-gray-600"></div>
                            <span className="xl:text-[20px] lg:text-[18px] text-[14px] font-semibold">Naturally-based ingredients</span>
                        </div>
                    </div>
                </section>

            </UserSliderStyle>
        </>
    );
};
export default SliderSection;